/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1685
 */

var r = require(/* 86 */"../1650/86/index")
var o = require(/* 1261 */"./1261")
r({
  global: true,
  forced: parseInt != o
}, {
  parseInt: o
})
